import Http from '../services/http.service';

const SuperAdmin = {};

// Accounts
SuperAdmin.assumeAccount = async (accountId) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/accounts/${accountId}/assume`)).data;
SuperAdmin.getAccounts = async (params) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/accounts`, {params})).data;
SuperAdmin.createAccount = async (account) => (await Http.get().post(`${process.env.VUE_APP_API}/1/superadmin/accounts`, account)).data;
SuperAdmin.editAccount = async (id, data) => (await Http.get().put(`${process.env.VUE_APP_API}/1/superadmin/accounts/${id}`, data)).data;
SuperAdmin.deleteAccount = async (id) => (await Http.get().delete(`${process.env.VUE_APP_API}/1/superadmin/accounts/${id}`)).data;

// Users
SuperAdmin.getUsers = async (params) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/users`, {params})).data;
SuperAdmin.getUser = async (id) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/users/${id}`)).data;
SuperAdmin.editUser = async (id, data) => (await Http.get().put(`${process.env.VUE_APP_API}/1/superadmin/users/${id}`, data)).data;
SuperAdmin.assumeUser = async (accountId) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/users/${accountId}/assume`)).data;

// Suites
SuperAdmin.upsertTestSuite = async (accountId, testSuite) => (await Http.get().put(`${process.env.VUE_APP_API}/1/superadmin/testsuite/${accountId}`, testSuite)).data;
SuperAdmin.getTestSuites = async (params) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/testsuite`, {params})).data;

// Tests
SuperAdmin.getTests = async (params) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/tests`, {params})).data;

// Agents
SuperAdmin.getAgents = async (params) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/agents`, {params})).data;

// Transients
SuperAdmin.getTransients = async (params) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/transients`, {params})).data;
SuperAdmin.getTransient = async (id) => (await Http.get().get(`${process.env.VUE_APP_API}/1/superadmin/transients/${id}`)).data;
SuperAdmin.deleteTransient = async (id) => (await Http.get().delete(`${process.env.VUE_APP_API}/1/superadmin/transients/${id}`)).data;

export default SuperAdmin;
